export default __webpack_public_path__ + "static/meta-partner-bd58ca79dde0abdc6331383f859ad436.png";